
import { useState, useEffect } from 'react';
import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { optimizeContentfulImage } from '../../utils/imageOptimization';
import { INLINES } from "@contentful/rich-text-types";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'; // Include Swiper styles

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function PageProjetsComestibles() {
    const [projetsComestiblesData, setProjetsComestiblesData] = useState(null); // Store the relevant fields

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await client.getEntries({ content_type: 'projetsComestibles' });

                //console.log(response);

                if (response.items.length > 0) {
                    const { albumPhoto01 = [], nomPage, texte, titre, url } = response.items[0].fields;

                    setProjetsComestiblesData({ albumPhoto01, nomPage, texte, titre, url }); // Store only relevant fields
                }
            } catch (error) {
                console.error('Error fetching projetsComestibles data:', error);
            }
        };

        fetchPage();
    }, []);

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };

    if (!projetsComestiblesData) {
        return null; // Prevents rendering errors while data is loading
    }

    return (
        <section className="section-projetsComestibles" data-content-type="projetsComestibles" id="projetsComestibles" data-background-color='#e0d5d5'>




            <div className='inner-container'>


                <div className="phrase">
                    {documentToReactComponents(projetsComestiblesData.titre, renderOptions)}
                </div>



                <div className="title">
                    <p>{projetsComestiblesData.nomPage}</p>
                </div>

                {/*   <div className="pictures-container">
                    <img src={projetsComestiblesData.albumPhoto01[0].fields.file.url} alt='xoxo' />
                </div> */}

                <div className="mySwiperContainer">

                    <Swiper
                        navigation={true}
                        modules={[Navigation, Keyboard]}
                        loop={true}
                        className="mySwiper"
                        keyboard={true}
                        mousewheel={true}
                        spaceBetween={10}
                        slidesPerView={'auto'}
                        centeredSlides={false}
                        slidesPerGroup={1}
                    >
                        {(projetsComestiblesData.albumPhoto01 ?? [])
                            .filter(photo => photo.fields?.file?.url) // Only include images with a valid URL
                            .map((photo, photoIndex) => (
                                <SwiperSlide key={photoIndex}>
                                    <img 
                                        src={optimizeContentfulImage(photo.fields.file.url)} 
                                        alt={`Slide ${photoIndex + 1}`}
                                        width={photo.fields.file.details?.image?.width}
                                        height={photo.fields.file.details?.image?.height}
                                    />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>

                <div className="description">
                    {documentToReactComponents(projetsComestiblesData.texte, renderOptions)}
                </div>

            </div>

        </section>
    );
}
